import { Component, OnInit } from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { HttpParams } from "@angular/common/http";
import { CurrencyPipe, formatDate } from "@angular/common";
import * as moment from "moment";
import { ReportsService } from "../../../consumer-report/reports.service";
import { ActivatedRoute } from "@angular/router";
import { ConsumersService } from "../../consumers.service";

@Component({
  selector: "manage-payment-report",
  templateUrl: "./payment-report.component.html",
  styleUrls: ["./payment-report.component.scss"],
  providers: [CurrencyPipe],
})
export class PaymentReportComponent
  extends FeaturesBaseComponent
  implements OnInit
{
  transactionFromDate;
  transactionToDate;

  searchValue: any;
  gridApi: any;
  isLogSelected: boolean = false;
  gridColumnApi: any;
  selectedRows: any;
  showEditPromotion: boolean;
  isUserLogsActive: boolean = true;
  isSystemLogsActive: boolean = false;
  rowData: any;
  columnDefs: any;
  defaultColDef: any;
  minFromDate: Date;
  maxDate: Date = new Date();
  minToDate: Date;
  transactionStartDate: string;
  transactionEndDate: string;
  retailerId: any;

  constructor(
    private service: ConsumersService,
    private currencyPipe: CurrencyPipe,
    private activeRoute: ActivatedRoute
  ) {
    super();
    var dt = new Date();
    dt.setDate(dt.getDate() - 30);
    this.retailerId = this.activeRoute.snapshot.params.userId;
    console.log(this.activeRoute);

    this.transactionToDate = moment(new Date()).format("LL");
    this.transactionFromDate = moment(dt).format("LL");
    let stratdate = formatDate(dt, "yyyy-MM-dd", "en");
    let todate = formatDate(new Date(), "yyyy-MM-dd", "en");
    let params: any = new HttpParams()
      .set("consumerId", this.retailerId)
      .set("startDate", stratdate)
      .set("endDate", todate);
    this.service
      .manageConsumerPaymentReport(this.retailerId, params)
      .subscribe((res) => {
        let resData: any = res;
        if (resData.httpcode == 200) {
          resData = resData.data;
          this.setGrid(resData);
        }
      });
    //this.setGrid()
  }
  setGrid(resData) {
    const self = this;
    this.rowData = resData;
    this.columnDefs = [
      {
        field: "createdDate",
        headerName: "Date Requested",
        width: 250,
        cellRenderer: (data) => {
          return moment(data.value).format("MM/DD/YYYY");
        },
      },
      {
        field: "createdTime",
        headerName: "Time",
        width: 250,
        cellRenderer: (data) => {
          return moment(data.value).format("hh:mm A");
        },
      },
      {
        field: "totalPayment",
        headerName: "Total Payment",
        width: 180,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "convenienceFee",
        headerName: "Convenience Fee",
        width: 250,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      // { field: "totalPayment", headerName: "Total Payment", width: 240 ,cellRenderer: (data) => { return this.currencyPipe.transform(data.value);}},
      { field: "consumerName", headerName: "Consumer Name", width: 230 },
      { field: "paymentType", headerName: "Payment Type", width: 200 },
      // { field: "bankName", headerName: "Bank Name", width: 210 },
      {
        field: "paymentStatus",
        headerName: "Payment Status",
        width: 210,
        cellRenderer: (params) => {
          return params.value == "Pending Approval" ? `Pending` : params.value;
        },
      },
      {
        field: "fee",
        headerName: "Carrier Fee",
        width: 200,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      { field: "autoPaymentStatus", headerName: "Auto Payment", width: 240 },
      { field: "promoCode", headerName: "Promo Code", width: 240 },
      { field: "creditCardType", headerName: "CC Type", width: 240 },
      { field: "paymentChannel", headerName: "Channel", width: 240 },
      { field: "cardNumber", headerName: "Last 4 digits of CC", width: 220 },
      { field: "ipAddress", headerName: "IP address", width: 240 },
      { field: "location", headerName: "Location", width: 240 },
      {
        field: "confirmationNumber",
        headerName: "Confirmation Number",
        width: 250,
      },
    ];
  }
  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Manager-Consmuer-Payment-Report.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      //
      if (cellParams && cellParams.column.colId === "") {
        return ""; //apply your timestamp formatter
      } else if (
        (cellParams && cellParams.column.colId === "createdDate") ||
        cellParams.column.colId === "settlementDate" ||
        cellParams.column.colId === "depositDate"
      ) {
        return moment(cellParams.value).format("MM/DD/YYYY"); //apply your timestamp formatter
      } else if (cellParams && cellParams.column.colId === "createdTime") {
        return moment(cellParams.value).format("hh:mm:ss:a");
      } else if (
        (cellParams && cellParams.column.colId === "fee") ||
        cellParams.column.colId === "totalPayment" ||
        cellParams.column.colId === "topUpAmount" ||
        cellParams.column.colId === "convenienceFee"
      ) {
        return this.currencyPipe.transform(cellParams.value);
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }

  handleExport(data: any) {
    let invoiceId = data;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onSelectUserLogs() {
    this.isUserLogsActive = true;
    this.isSystemLogsActive = !this.isUserLogsActive;
  }

  onSelectSystemLogs() {
    this.isSystemLogsActive = true;
    this.isUserLogsActive = !this.isSystemLogsActive;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();
    if (
      this.selectedRows &&
      this.selectedRows != [] &&
      this.selectedRows.length! > 0
    ) {
      this.isLogSelected = true;
      return;
    }
    this.isLogSelected = false;
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.transactionFromDate = moment(e.value).format("LL");
    this.transactionStartDate = formatDate(e.value, "yyyy-MM-dd", "en");
  }

  changeToDate(e) {
    this.transactionToDate = moment(e.value).format("LL");
    this.transactionEndDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (
      this.transactionStartDate != null &&
      this.transactionStartDate != undefined
    ) {
      let params: any = new HttpParams()
        .set("consumerId", this.retailerId)
        .set("startDate", this.transactionStartDate)
        .set("endDate", this.transactionEndDate);
      this.service
        .manageConsumerPaymentReport(this.retailerId, params)
        .subscribe((res) => {
          let resData: any = res;
          if (resData.httpcode == 200) {
            resData = resData.data;
            this.setGrid(resData);
          }
        });
    }
  }
}
